import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent implements OnInit {
  title: string;
  message: string;
  confirm: string;
  showFinish:boolean=false;
  FinishButtonText:string='Finish'

  constructor(public dialogRef: MatDialogRef<ConfirmDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogModel) {
    // Update view with given values
    this.title = data.title;
    this.message = data.message;
    this.confirm = data.confirm;

    if(this.message === "You have reached the end of the documents. Select an option below to Finish & Next Form or go back to the beginnings." ||
       this.message === "You’ve reached the end of the document. Select an option below to Finish or go back to the beginning.") 
       {
           this.showFinish = true;
          if (this.message.includes("You’ve")) {
            this.FinishButtonText = "Finish";
          } else {
            this.FinishButtonText = "Finish & Next Form";
          }
        } else {
          this.showFinish = false;
        }
    }

  ngOnInit(): void {
  }

  onConfirm() {
    // Close the dialog, return true
    this.dialogRef.close(true);
  }

  onDismiss(): void {
    // Close the dialog, return false
    this.dialogRef.close(false);
  }

  onDismissEdit(): void {
    // Close the dialog, return false
    this.dialogRef.close('MoveToNextDoc');
  }

  onFinish(): void {
    // Close the dialog, return false
    this.dialogRef.close("Finish");
  }  

}

/**
 * Class to represent confirm dialog model.
 *
 * It has been kept here to keep it as part of shared component.
 */
export class ConfirmDialogModel {

  constructor(public title: string, public message: string, public confirm:string) {
  }
}
